import React, { Component } from "react";

export default class ButtonEdit extends Component {
  handleShowModalDesign() {
    let { handleUpdateState } = this.props;
    let listDesign = JSON.parse(localStorage.getItem("products")) || [];

    if (listDesign.length === 0) {
      handleUpdateState("isShowDialogMessage", true);
      handleUpdateState(
        "dialogMessage",
        "このデバイスにはデザインが保存されていません"
      );

      return;
    }
    handleUpdateState("isShowModalListDesign", true);
  }

  render() {
    return (
     /* <button className="btn_edit" onClick={() => this.handleShowModalDesign()}>
        <img src="/img/design_new.png" alt="" />
        <span>デザイン一覧</span>
      </button>*/
      <button className="btn_stock" onClick={() => this.handleShowModalDesign()}>
        <svg className={'icon-upt'}>
          <use xlinkHref={`#icon-poster`} />
        </svg>
        <span>デザインを開く</span>
      </button>
    );
  }
}
